import React, { Component } from "react";
import AppBarComponent from "./Parts/appBarComponent";
import StorageService from "../Services/storageService";
import { authMethode, authServiceInstance, userDetailsStorageKey, userMenuStorageKey, whenAppLoad } from "../General/globals";
import GenericPageComponent from "./Pages/genericPageComponent";
import { Grid } from "@mui/material";
// import store from "../AppRedux/store";
 import { ExecuteLayoutEventMethods, SetCreateDataSet } from "../General/commonFunctions";
import PageHeaderSection from './Parts/pageHeaderSection';
 import PageFooterSection from "./Parts/pageFooterSection";
import PopupComponent from "./popupComponent";
 

class AuthorizedComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userMenu: null
        };
    }
 
    async getDetailsFromServer(){
        let _userInfo = await this.getCurrentUserDetails();
        let _userMenu =  await this.loadUserSpecificMenu(_userInfo.userrole);
        return {
            _userInfo, _userMenu
        }; 
    }
    
    getDetailsFromLocal(){
        let _userInfo = new StorageService().getJsonValue(userDetailsStorageKey);
        let _userMenu = new StorageService().getJsonValue(userMenuStorageKey);
    
        return {
            _userInfo, _userMenu
        }; 
    }

    async initialSetup(){
        let {_userInfo, _userMenu} =  ( 
            authMethode === "cookie" ? 
                await this.getDetailsFromServer() :  
                await this.getDetailsFromLocal()); 
      
        _userMenu =
            _userMenu && _userMenu?.map &&
            _userMenu?.map(t => {
                let actionObj = JSON.parse(t.action);
                t.action = actionObj;
                return t;
            });

        if (!_userInfo || !_userMenu) {

            console.log("Tampered UserInfo! Dispatching Logout...!");
            ExecuteLayoutEventMethods([{ "exec": "logout" }]);
            return;
        }


        // store.dispatch(storeUser(userInfo)); //Redux
        SetCreateDataSet({ "dset": "_userinfo" }, _userInfo); //Redux
        SetCreateDataSet({ "dset": "_usermenu" }, _userMenu); //Redux
        this.setState({
            userMenu: _userMenu
        });
        ExecuteLayoutEventMethods(whenAppLoad, null, null, true); //Appload from Initjson

    }



    async componentDidMount() {
        await this.initialSetup();
        this.handleRouting();
        // ownStore.dispatch(hideAppBusy());

    }

    async getCurrentUserDetails() {
        let userDetails = await authServiceInstance.loadUserDetails();
        if (userDetails && userDetails.length > 0) {
             return userDetails[0];
        }
        return null;
    }
    async loadUserSpecificMenu(_userrole) {
        let _userMenu = await authServiceInstance.loadUserMenu({ userrole: _userrole });
        new StorageService().setJsonValue(userMenuStorageKey, _userMenu);
        return _userMenu; 
    }

    async handleRouting() {

        let docNoFromRoute = this.props?.match?.params["permalink"];
        let pageToShow = this.state.userMenu?.filter(t => docNoFromRoute === t.permalink);
        if (pageToShow?.length <= 0) {
            pageToShow = this.state.userMenu?.filter(t => t.homepage && t.homepage.toLowerCase() === "true");
        }
        if (pageToShow?.length > 0) {
            // window.location.hash = "#" + pageToShow[0]?.permalink;
            await ExecuteLayoutEventMethods([{
                "exec" : "setdataset", 
                "args" : {
                    "dset" : "pagemenuinfo",
                    "data" :pageToShow[0]
                }
            }], null, null, true); 
            await ExecuteLayoutEventMethods(pageToShow[0]?.action, null, null, true);
        }
    }

    render() {
        if(!this.state.userMenu) return <></>;
        return (
            // <ThemeProvider theme={this.theme} >
            <>
                <div className="main-wrap" >
                    {this.props.pageInfo &&  
                        <AppBarComponent {...this.props.pageInfo?.appbar} userMenu={this.state.userMenu} /*executeMenuRouting={this.executeMenuRouting.bind(this)} />*/ ></AppBarComponent>
                    }
                    <div className="page-wrap" style={this.props.pageInfo?.style}>

                        <PageHeaderSection pageHeader={this.props.pageInfo?.pageheader} />

                        <Grid container className="page-container" >
                            <GenericPageComponent pageInfo={this.props.pageInfo} />
                        </Grid>
                    </div>
                    <PageFooterSection pageFooter={this.props.pageInfo?.pagefooter} userMenu={this.state.userMenu} />

                </div>
                <PopupComponent  />
            </>
            // </ThemeProvider>
        );
    }

}

export default AuthorizedComponent; 